import React, { useEffect } from "react";
import "./TopSlidePanel.css";

const TopSlidePanel = ({
    open,
    title,
    onClose,
    children,
    height = 320,
    closeOnBackdrop = true,
}) => {
    useEffect(() => {
        if (!open) return;

        const onKeyDown = (e) => {
            if (e.key === "Escape" && onClose) {
                onClose();
            }
        };

        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="ts-panel-root">
            <div
                className="ts-panel-backdrop"
                onClick={() => {
                    if (closeOnBackdrop && onClose) {
                        onClose();
                    }
                }}
            />

            <div className="ts-panel" style={{ height }}>
                <div className="ts-panel-header">
                    <div className="ts-panel-title">{title}</div>

                    <button
                        type="button"
                        className="ts-panel-close"
                        onClick={() => {
                            if (onClose) {
                                onClose();
                            }
                        }}
                        aria-label="Fechar"
                        title="Fechar"
                    >
                        ×
                    </button>
                </div>

                <div className="ts-panel-body">{children}</div>
            </div>
        </div>
    );
};

export default TopSlidePanel;
